App.controller('ZochHealthPzuwNotificationCtrl', ['$scope', '$sce', '$state', '$stateParams', 'zochaPzuwHealthInsuranceService', 'popUpService', function ($scope, $sce, $state, $stateParams, zochaPzuwHealthInsuranceService, popUpService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Zgłoszenie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.healthPzuw.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.home.zoch.healthPzuw.list');
    }

    $scope.type = 'UNABLE_TO_DEDUCT';

    $scope.sendNotification = function (uuid) {
        let vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        let criteria = {
            uuid: uuid,
            data: {
                reason: $scope.reason, type: $scope.type
            }
        };

        zochaPzuwHealthInsuranceService.sendNotification(criteria).then(function (data) {
            if (data.status === 200) {
                popUpService.showPopUp({
                    ev: '',
                    head: 'Wiadomość wysłana',
                    content: 'Zgłoszenie przesłane poprawnie.',
                    text: 'Przejdź do listy deklaracji',
                    target: 'root.home.zoch.healthPzuw.list({"user": null})',
                    tpl: 'info-big'
                });
            } else {
                popUpService.showPopUpWithError(data.data, {
                    ev: '',
                    head: 'Wiadomość nie została wysłana',
                    content: 'Nie udało się przesłać zgłoszenia',
                    text: '',
                    target: ''
                });
            }
        });
    };
}]);
